(function($) {
	$.fn.primarymenu = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.primarymenu.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            var count = $this.children('li').size();

            balance($this);

            // hide the tooltip when the user expands the menu, otherwise the tooltip is over the top of the menu
            $this.children('li').find('> span .ui-icon-text').on('click', function(){
                $('.ui-tooltip').remove();
            });
        });
	};
	//
	// plugin defaults
	//
	$.fn.primarymenu.defaults = {
	};

    /**
     * Balancing rules:
     * 1. Each <li> is trimmed to take no more than its fair proportion of space. i.e. if there are 4 <li> none can be larger than 25%.
     * 2. Any remaining space is allocated evenly amongst remaining <li>.
     */
    function balance($ul) {
        var maxWidth = $ul.width();
        var $li = $ul.children('li');
        var currentWidth = 0;
        $li.each(function(){
            currentWidth = currentWidth + $(this).outerWidth();
        });
        if (currentWidth > maxWidth) {
            // The size <li> get trimmed to
            var trimmedWidth = parseInt(maxWidth / $li.size(), 10);
            // Variable to keep track if how much space we have allocated
            var remainingWidth = maxWidth;
            // 1.
            $li.each(function () {
                var $li = $(this);
                var $text = $li.find('> a,> span .ui-icon-text');
                // Cache the original width
                $li.data('original-width', $li.outerWidth());
                $li.data('padding', ($li.outerWidth() - $text.width()));
                var originalWidth = $li.data('original-width');
                var width = originalWidth;
                $text.addClass('trimmed');
                if (originalWidth > Math.min(trimmedWidth, remainingWidth)) {
                    width = Math.min(trimmedWidth, remainingWidth);
                    $text.attr('title', $text.text());
                }
                $text.css('width', (width-$li.data('padding')) + 'px');
                remainingWidth = remainingWidth - $li.outerWidth();
            });
            // 2.
            var i = 0;
            var prevRemainingWidth = -1;
            while (remainingWidth > 0 && prevRemainingWidth != remainingWidth && i < 100) {
                prevRemainingWidth = remainingWidth;
                var $trimmedLi = $ul.find('.trimmed').closest('li');
                var remainingShare = parseInt(remainingWidth / $trimmedLi.size(), 10);
                if (remainingShare == 0) {
                    // There are more trimmed <li> than remaining pixels, so we add 1px to each <li> until we run out of space.
                    remainingShare = 1;
                }
                $trimmedLi.each(function () {
                    if (remainingWidth > 0) {
                        var $li = $(this);
                        remainingWidth = increaseTrimmedLi($li, remainingShare, remainingWidth);
                    }
                });
                i++;
            }
        }
    }

    function increaseTrimmedLi($li, amount, remainingWidth) {
        var $text = $li.find('> a,> span .ui-icon-text');
        var width = $li.outerWidth();
        var maxWidth = width + amount;
        var originalWidth = $li.data('original-width');
        if (originalWidth > width) {
            remainingWidth = remainingWidth + width;
            width = Math.min(originalWidth, maxWidth);
            if (width == originalWidth) {
                $text.removeAttr('title');
            }
            $text.css('width', (width-$li.data('padding')) + 'px');
            remainingWidth = remainingWidth - $li.outerWidth();
        }
        return remainingWidth;
    }

})(jQuery);